import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './js/App';
import { GoogleOAuthProvider } from "@react-oauth/google"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <GoogleOAuthProvider clientId='492014128201-o2pfqfgaq0cclus0477bs0i7aqccbkko.apps.googleusercontent.com'>
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  //  </GoogleOAuthProvider> 
);

